import { RouteConfig } from "vue-router";

import RvsCalculationPage from "@/features/rvsCalculation/pages/RvsCalculationPage.vue";

export const RvsCalculationRouter = (): RouteConfig[] => [
  {
    name: "RvsCalculationPage",
    path: `/rvs-calculation`,
    component: RvsCalculationPage,
    meta: { title: "RVS Calculation" },
    beforeEnter: (to, from, next) => {
      const { meta } = to;
      document.title = meta?.title;
      next();
    },
  },
];
